import React, { useCallback, useEffect, useState } from 'react'
import Layout from '../../layout/Layout'
import { Form, InputGroup, OverlayTrigger, Table, Tooltip } from 'react-bootstrap'
import CustomPagination from '../../components/CustomPagination';
import { Link } from 'react-router-dom';
import DeleteModal from '../../components/DeleteModal';
import ViewBlogs from '../../components/blog/ViewBlogs';
import axiosInstance from '../../utils/axiosConfig';
import NoDateFound from '../../components/NoDateFound';
import Loader from '../../components/loader/Loader';
import { useGlobalState } from '../../context/GlobalStateContext';
import * as CustomToast from '../../components/CustomToastMessage';


function Blogs() {
    const [blogs, setBlogs] = useState([]);
    const [activeLoading, setActiveLoading] = useState(false);
    const {
        loading, setLoading,
        search,
        pagination, setPagination,
        handleSearch,
        handleLimitChange,
    } = useGlobalState();

    const fetchBlogs = useCallback(
        async (page = 1, limit = 10, searchQuery = '') => {
            try {

                setLoading(true);
                const response = await axiosInstance.get(`${process.env.REACT_APP_BACKEND_URL}/api/blogs/admin/list`, {
                    params: {
                        page,
                        limit,
                        search: searchQuery
                    }
                });
                if (response.data.success) {
                    setBlogs(response.data.data);
                    setPagination(response.data.pagination);
                } else {
                    setBlogs([]);
                    setPagination(prev => ({
                        ...prev,
                        currentPage: 1,
                        totalPages: 1,
                        totalItems: 0
                    }));
                }
            } catch (error) {

                console.error(error.response?.data?.message || 'Error fetching blogs')
                setBlogs([]);
                setPagination(prev => ({
                    ...prev,
                    currentPage: 1,
                    totalPages: 1,
                    totalItems: 0
                }));
            } finally {
                setLoading(false);
            }
        }, [setLoading, setPagination])

    const handleDelete = async (id) => {
        try {
            setLoading(true);
            const response = await axiosInstance.delete(`${process.env.REACT_APP_BACKEND_URL}/api/admin/blog/delete/${id}`);
            if (response.data.success) {
                CustomToast.success(response.data.message);
                fetchBlogs(pagination.currentPage, pagination.limit, search);
            }
        } catch (error) {
            if (error.response.data.status === 400) {
                CustomToast.error(error.response?.data?.message);
            }
            console.error(error.response?.data?.message || 'Error deleting blog');
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchBlogs(pagination.currentPage, pagination.limit, search);
    }, [pagination.currentPage, pagination.limit, search, fetchBlogs]);



    const [trendingLoading, setTrendingLoading] = useState(false);

    const handleTrendingToggle = async (id, currentStatus) => {
        try {
            setTrendingLoading(true);
            const response = await axiosInstance.put(`${process.env.REACT_APP_BACKEND_URL}/api/admin/blog/trending/${id}`, {
                trending: !currentStatus
            });
            if (response.data.success) {
                setBlogs(prevBlogs =>
                    prevBlogs.map(blog =>
                        blog._id === id ? { ...blog, trending: !currentStatus } : blog
                    )
                );
                CustomToast.success(response.data.message);
            }
        } catch (error) {
            if (error.response.data.status === 400) {
                CustomToast.error(error.response?.data?.message);
            }
            console.error(error.response?.data?.message || 'Internal server error');
        } finally {
            setTrendingLoading(false);
        }
    };

    const handleToggleActiveStatus = async (id, currentStatus) => {
        try {
            setActiveLoading(true);
            const response = await axiosInstance.put(`${process.env.REACT_APP_BACKEND_URL}/api/admin/blog/status/${id}`, {
                isShown: !currentStatus
            });
            if (response.data.success) {
                setBlogs(prevBlogs =>
                    prevBlogs.map(blog =>
                        blog._id === id ? { ...blog, isShown: !currentStatus } : blog
                    )
                );
                CustomToast.success(response.data.message);
            }
        } catch (error) {
            if (error.response.data.status === 400) {
                CustomToast.error(error.response?.data?.message);
            }
            console.error(error.response?.data?.message || 'Internal server error');
        } finally {
            setActiveLoading(false);
        }
    }
    return (
        <Layout title="Recipe blogs list">
            <main>

                <div className="card page-card">
                    <div className="card-header d-flex flex-column flex-md-row justify-content-between align-items-start align-items-md-center gap-3">
                        <div className='d-flex align-items-center gap-3'>
                            <p>Show</p>
                            <Form.Select
                                aria-label="Default select example"
                                value={pagination.limit}
                                onChange={handleLimitChange}
                            >
                                <option value="10">10</option>
                                <option value="25">25</option>
                                <option value="50">50</option>
                            </Form.Select>
                            <p>entries</p>
                        </div>

                        <div className='d-flex flex-column flex-md-row  align-items-start align-items-md-center gap-3 sm-w-100'>
                            <div className='header-search'>
                                <InputGroup>
                                    <InputGroup.Text id="basic-addon1" className='bg-transparent'>

                                        <img src="/images/png/search.png" width={20} alt="" />
                                    </InputGroup.Text>
                                    <Form.Control
                                        type="search"
                                        className='border-start-0 ps-0'
                                        placeholder="search here..."
                                        value={search}
                                        onChange={handleSearch(fetchBlogs)}
                                    />
                                </InputGroup>
                            </div>
                            <Link to="/blogs/add" className='btn-primary fs-16 fw-600 d-flex justify-content-center align-items-center gap-2 px-3 add-hover'>
                                <img src="/images/png/plus.png" width={22} alt="" />
                                Add Recipe Blog
                            </Link>
                        </div>
                    </div>
                    <div className="card-body">
                        <div className="overflow-auto">
                            <Table>
                                <thead>
                                    <tr>
                                        <th>Id</th>
                                        <th>Image</th>
                                        <th>Title</th>
                                        <th>Content</th>
                                        <th>Date</th>
                                        <th width="100">Status</th>
                                        <th className='text-center'>Trending</th>
                                        <th width="100" className='text-center'>Action</th>
                                    </tr>
                                </thead>
                                <tbody>{loading ?
                                    (<tr>
                                        <td colSpan="7" className="text-center">
                                            <Loader />
                                        </td>
                                    </tr>) : blogs.length > 0 ? (
                                        blogs.map((item, index) => (
                                            <tr key={item._id}>
                                                <td>{(pagination.currentPage - 1) * pagination.limit + index + 1}</td>
                                                <td>
                                                    <img src={(item?.phoneImage || item?.blogImage) ? `${process.env.REACT_APP_BACKEND_URL}/${item?.phoneImage || item?.blogImage}` : "https://img.freepik.com/premium-photo/adult-beautiful-woman-working-out-light-background_470178-19669.jpg"} width={119} height={119} className='rounded-3 object-fit-cover img-sm-w' alt="" />
                                                </td>
                                                <td>
                                                    <p className='mb-0 table-td-300'>{item.title ? item.title : "-"}</p>
                                                </td>
                                                <td className='gray-text'>
                                                    <p className='mb-0 table-td-500 limit-lines' dangerouslySetInnerHTML={{ __html: item.content ? item.content : "" }} />
                                                </td>
                                                <td className='table-td-100'>
                                                    <p className='mb-0 '>{item.createdAt ? new Date(item.createdAt).toISOString().split('T')[0] : "-"}</p>
                                                </td>
                                                <td>
                                                    <div className='table-td-150 d-flex justify-content-center'>
                                                        <Form.Check
                                                            type="switch"
                                                            id={`active-switch-${item._id}`}
                                                            className='custom-switch'
                                                            checked={item.isShown || false}
                                                            onChange={() => handleToggleActiveStatus(item._id, item.isShown)}
                                                            disabled={activeLoading}
                                                        />
                                                    </div>
                                                </td>
                                                <td>
                                                    <div className='table-td-150 d-flex justify-content-center'>
                                                        <Form.Check
                                                            type="switch"
                                                            id={`trending-switch-${item._id}`}
                                                            className='custom-switch'
                                                            checked={item.trending || false}
                                                            onChange={() => handleTrendingToggle(item._id, item.trending)}
                                                            disabled={trendingLoading}
                                                        />
                                                    </div>
                                                </td>
                                                <td>
                                                    <div className='d-flex align-items-center gap-2'>
                                                        <ViewBlogs blog={item} />
                                                        <OverlayTrigger
                                                            key="top"
                                                            placement="top"
                                                            overlay={
                                                                <Tooltip id="tooltip-top">
                                                                    Edit
                                                                </Tooltip>
                                                            }
                                                        >
                                                            <Link to={`/blogs/edit/${item._id}`}>
                                                                <img src="/images/png/edit.png" className="pointer" width={35} alt="action" />
                                                            </Link>

                                                        </OverlayTrigger>
                                                        <DeleteModal
                                                            onConfirm={() => handleDelete(item._id)}
                                                            loading={loading}
                                                            flag={"recipe"}
                                                        />
                                                    </div>
                                                </td>
                                            </tr>
                                        ))
                                    ) : (
                                        <tr>
                                            <td colSpan="10" className="text-center">
                                                <NoDateFound />
                                            </td>
                                        </tr>
                                    )}
                                </tbody>
                            </Table>
                        </div>
                        <CustomPagination
                            currentPage={pagination.currentPage}
                            totalPages={pagination.totalPages}
                            totalItems={pagination.totalItems}
                            limit={pagination.limit}
                            onPageChange={(page) => setPagination(prev => ({ ...prev, currentPage: page }))}
                        />
                    </div>
                </div>

            </main>
        </Layout>
    )
}

export default Blogs